export enum CARRIER_LINE_OF_BUSINESS_TYPE {
  Life = 'Life',
  Annuity = 'Annuity',
}

export enum CARRIER_ORGANIZATION_TYPE {
  Individual = 'Individual',
  Corp = 'Corp',
}
